import { render, staticRenderFns } from "./my_incidents.vue?vue&type=template&id=39471424"
import script from "./my_incidents.vue?vue&type=script&lang=js"
export * from "./my_incidents.vue?vue&type=script&lang=js"
import style0 from "./my_incidents.vue?vue&type=style&index=0&id=39471424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports